import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { FacturaService } from 'app/modules/factura/lista-facturas/factura.service';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-dialog-new-place',
  templateUrl: './dialog-new-place.component.html',
  styleUrls: ['./dialog-new-place.component.scss']
})
export class DialogNewPlaceComponent implements OnInit {

  lugarExpedicionForm: FormGroup;
  lstPais: any[] = [];
  lstEstado: any[] = [];
  lstMunicipio: any[] = [];
  lstAsentamiento: any[] = [];
  isColoniaManual: boolean = false;
  modificarDatos: boolean = false;

  rfcPaisOnly: boolean = true;
  rfcEstadoOnly: boolean = true;
  rfcMunicipioOnly: boolean = true;

  get isPaisReadOnly() :boolean { return this.rfcPaisOnly; }
  get isEstadoReadOnly() :boolean { return this.rfcEstadoOnly; }
  get isMunicipioReadOnly() :boolean { return this.rfcMunicipioOnly; }

  constructor(
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DialogNewPlaceComponent>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private coalService: CoalService,
    private store: Store<AppState>,
    private _facturaService: FacturaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.lugarExpedicionForm = this._formBuilder.group({
      nombreLugar: [null, Validators.required]
      , descripcionLugar: [null]
      , idOperacion: [null]
      , CP: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      calle: [null],
      noExterior: [null],
      noInterior: [null],
      colonia: [null],
      municipio: [null],
      estado: [null],
      pais: [null],
      coloniaManual: [null]
    });

    if (data && data.attributes) {
      this.modificarDatos = true;
      this.lugarExpedicionForm.controls.nombreLugar.setValue(data.attributes?.nombre);
      this.lugarExpedicionForm.controls.descripcionLugar.setValue(data.attributes?.descripcion);
      this.lugarExpedicionForm.controls.CP.setValue(data.attributes?.dir_direccion?.data?.attributes?.codigoPostal);
      this.lugarExpedicionForm.controls.calle.setValue(data.attributes?.dir_direccion?.data?.attributes?.calle);
      this.lugarExpedicionForm.controls.noExterior.setValue(data.attributes?.dir_direccion?.data?.attributes?.noExterior);
      this.lugarExpedicionForm.controls.noInterior.setValue(data.attributes?.dir_direccion?.data?.attributes?.noInterior);

      this.consultaSepomex();
      this.lugarExpedicionForm.controls.CP.disable();

    }
  }

  ngOnInit(): void {
    this.getPaises();
  }

  getPaises() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`dir-paises?filters[nombre][$eq]=México`)
    .subscribe((res: any) => {
      this.store.dispatch(OcultarSpinner());
      this.lstPais = res.data;
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
      this._snackBar.open(
        'Ocurrió un error al cargar los paises.',
        'OK',
        { duration: 2500}
      )
    })
  }

  async consultaSepomex() {
    try {
        if (!this.lugarExpedicionForm.controls.CP.valid) {
            return;
        }
        this.store.dispatch(MostrarSpinner());
        const CP = this.lugarExpedicionForm.value.CP;

        const res = await  this._facturaService.getDataCodigoPostal(CP);
        if (res.success) {
            let pais         = res.paises[0].data.id;
            let estado       = res.estados[0].data.id;
            let municipio    = res.municipios[0].data.id;
            let asentamiento = res.asentamientos[0].data.id;

            this.lugarExpedicionForm.controls.pais.setValue(pais);
            this.lstEstado = res.estados.map(e => e.data);

            this.lugarExpedicionForm.controls.estado.setValue(estado);
            this.lstMunicipio = res.municipios.map(e => e.data);

            this.lugarExpedicionForm.controls.municipio.setValue(municipio);
            this.lstAsentamiento = res.asentamientos.map(e => e.data);

            this.lugarExpedicionForm.controls.colonia.setValue(asentamiento);
        } else {
            this.resetValues();
            this.lstAsentamiento = [];
            this._snackBar.open("No se encontraron coincidencias de CP", 'OK', {
                duration: 3000,
            });
        }

        this.store.dispatch(OcultarSpinner());
    } catch(error) {
        /*this.store.dispatch(
            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        );*/
        this._snackBar.open("No se encontraron coincidencias de CP", 'OK', {
            duration: 3000,
        });
        this.store.dispatch(OcultarSpinner());
    }
  }

  /*consultaSepomex() {
    if (!this.lugarExpedicionForm.controls.CP.valid) {
      return;
    }
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`dir-codigos-postales?filters[cp]=${this.lugarExpedicionForm.value.CP}&populate[0]=dir_asentamiento.dir_municipio.dir_estado.dir_pai`)
    .subscribe((res: any) => {
      if (res.data[0]?.id) {
        this.lugarExpedicionForm.controls.pais.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.attributes?.dir_estado?.data?.attributes?.dir_pai?.data?.id);
        this.lugarExpedicionForm.controls.estado.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.attributes?.dir_estado?.data?.id);
        this.lugarExpedicionForm.controls.municipio.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.id);
        this.lugarExpedicionForm.controls.colonia.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.id);
        this.lugarExpedicionForm.controls.pais.disable();
        this.lugarExpedicionForm.controls.estado.disable();
        this.lugarExpedicionForm.controls.municipio.disable();
        this.changePais();
        this.changeEntidad();
        this.changeMunicipio();
      } else {
        this.resetValues();
        this._snackBar.open(
          'No se encontraron coincidencias con ese CP.',
          'OK',
          { duration: 2500}
        )
      }
        this.store.dispatch(OcultarSpinner());
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    })
  }*/

  changePais() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`dir-estados?filters[dir_pai]=${this.lugarExpedicionForm.controls.pais.value}`)
    .subscribe((res: any) => {
      this.lstEstado = res.data;
      this.store.dispatch(OcultarSpinner());
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    });
  }

  changeEntidad() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`dir-municipios?filters[dir_estado]=${this.lugarExpedicionForm.controls.estado.value}&pagination[start]=0&pagination[limit]=54000`)
    .subscribe((res: any) => {
      this.lstMunicipio = res.data;
      this.store.dispatch(OcultarSpinner());
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    });
  }

  changeMunicipio() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`dir-asentamientos?filters[dir_municipio]=${this.lugarExpedicionForm.controls.municipio.value}`)
    .subscribe((res: any) => {
      this.lstAsentamiento = res.data;
      this.store.dispatch(OcultarSpinner());
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    });
  }

  resetValues() {
    this.lugarExpedicionForm.controls.pais.setValue(null);
    this.lugarExpedicionForm.controls.estado.setValue(null);
    this.lugarExpedicionForm.controls.municipio.setValue(null);
    this.lugarExpedicionForm.controls.colonia.setValue(null);
  }

  addPlace() {
    this.lugarExpedicionForm.markAllAsTouched();
    this.lugarExpedicionForm.updateValueAndValidity();

    if(!this.lugarExpedicionForm.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: 'Desea guardar este registro?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let data = {
          calle: this.lugarExpedicionForm.value.calle,
          noExterior: this.lugarExpedicionForm.value.noExterior,
          noInterior: this.lugarExpedicionForm.value.noInterior,
          pais: this.lugarExpedicionForm.value.pais,
          estado: this.lugarExpedicionForm.value.estado,
          municipio: this.lugarExpedicionForm.value.municipio,
          asentamiento: !this.isColoniaManual ? this.lugarExpedicionForm.value.colonia : undefined,
          nombre: this.lugarExpedicionForm.value.nombreLugar,
          descripcion: this.lugarExpedicionForm.value.descripcionLugar,
          cp: this.lugarExpedicionForm.value.CP,
          isColoniaManual: this.isColoniaManual,
          coloniaManual: this.isColoniaManual ? this.lugarExpedicionForm.value.coloniaManual : undefined,
          ope_empresa: this.data.idEmpresa
        }

        this.store.dispatch(MostrarSpinner());
        this.coalService.postService('ope-direccion-empresas/newAddress', data)
        .subscribe((res: any) => {
          this.store.dispatch(OcultarSpinner());
          this._snackBar.open(
            'Datos guardados correctamente',
            'OK',
            {duration: 2500},
          )
          this.close(1);
        }, (err: any) => {
          this._snackBar.open(
            err.error.error.message,
            'OK',
            {duration: 2500},
          )
          this.store.dispatch(OcultarSpinner());
        });
      }
    });
  }

  modifyPlace() {
    this.lugarExpedicionForm.markAllAsTouched();
    this.lugarExpedicionForm.updateValueAndValidity();

    if(!this.lugarExpedicionForm.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea modificar este registro?'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let data = {
          data: {
            calle: this.lugarExpedicionForm.value.calle,
            noExterior: this.lugarExpedicionForm.value.noExterior,
            noInterior: this.lugarExpedicionForm.value.noInterior,
            pais: this.lugarExpedicionForm.value.pais,
            estado: this.lugarExpedicionForm.value.estado,
            municipio: this.lugarExpedicionForm.value.municipio,
            asentamiento: !this.isColoniaManual ? this.lugarExpedicionForm.value.colonia : undefined,
            nombre: this.lugarExpedicionForm.value.nombreLugar,
            descripcion: this.lugarExpedicionForm.value.descripcionLugar,
            cp: this.lugarExpedicionForm.value.CP,
            isColoniaManual: this.isColoniaManual,
            coloniaManual: this.isColoniaManual ? this.lugarExpedicionForm.value.coloniaManual : undefined,
            ope_empresa: this.data.idEmpresa
          }
        }

        this.store.dispatch(MostrarSpinner());
        this.coalService.putService(`ope-direccion-empresas/${this.data.id}`, data)
        .subscribe((res: any) => {
          this.store.dispatch(OcultarSpinner());
          this._snackBar.open(
            'Datos guardados correctamente',
            'OK',
            {duration: 2500},
          )
          this.close(1);
        }, (err: any) => {
          this._snackBar.open(
            err.error.error.message,
            'OK',
            {duration: 2500},
          )
          this.store.dispatch(OcultarSpinner());
        });
      }
    });

  }

  changeVerManualmente(value: boolean) {
    // Cambial el valor de verManualmente a la inversa
    this.isColoniaManual = value; //!this.isColoniaManual;
    this.updateControls();
  }
  updateControls() {
    if(this.isColoniaManual) {
        this.lugarExpedicionForm.controls.colonia.setValidators(null);
        this.lugarExpedicionForm.controls.colonia.updateValueAndValidity();
        this.lugarExpedicionForm.controls.coloniaManual.setValidators([Validators.required]);
        this.lugarExpedicionForm.controls.coloniaManual.updateValueAndValidity();
    } else {
        this.lugarExpedicionForm.controls.colonia.setValidators([Validators.required]);
        this.lugarExpedicionForm.controls.colonia.updateValueAndValidity();
        this.lugarExpedicionForm.controls.coloniaManual.setValidators(null);
        this.lugarExpedicionForm.controls.coloniaManual.updateValueAndValidity();
    }
  }

  close(status) {
    this.dialogRef.close({
      success: status
    });
  }
}
